import React from "react"
import DefaultBusinessMeta from "./DefaultBusinessMeta"
import DefaultOGTags from "./DefaultOGTags"
import DefaultTwitterMeta from "./DefaultTwitterMeta"
import OrganizationJsonLD from "./OrganizationJsonLD"

export const SiteMetadata = () => {
  return (
    <>
      <OrganizationJsonLD />
      <DefaultOGTags />
      <DefaultTwitterMeta />
      <DefaultBusinessMeta />
    </>
  )
}
